import React from "react";
import PhoneInput from 'react-phone-input-2';
import { Form, Input, Modal } from "antd";
import api from "../../api/api/index";
import { defaultFormValues } from "../../api/requiredFunctions";
import { bindActionCreators } from "redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { profileAction } from "../../redux-stuffs/actions/profile_action";
import queryString from "query-string";
import { accessTokenState, phoneState, loginOtpVerifyCount, loginOtpVerifyDate } from '../../atoms';
import withRecoil from '../../withRecoil';
import LanguageSwitcher from '../LanguageSwitcher';
import { withTranslation } from 'react-i18next';

function error(title, content) {
    Modal.error({
        title,
        content,
    });
}

class LoginComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { phone: "" };
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        const { t } = this.props;

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values.phone = values.phone.replace(/[- )(]/g, '');
                let finalBody = { ...defaultFormValues(), ...values };

                fetch(`${api.main}/phone_login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    body: queryString.stringify(finalBody)
                })
                    .then(response => {
                        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                        return response.json();
                    })
                    .then(res => {
                        if (res.status !== 105) {
                            return error(t('common:error'), res.message);
                        } else {
                            if (this.props.recoilStates.loginOtpVerifyCount.state >= 3) {
                                const nowDate = new Date().getTime();
                                const thenDate = this.props.recoilStates.loginOtpVerifyDate.state.getTime();
                                if (nowDate - thenDate < 900000) {
                                    Modal.error({
                                        title: t('common:error'),
                                        content: t('login:otpTooManyTries'),
                                    });
                                } else {
                                    this.props.recoilStates[loginOtpVerifyDate.key].setState("");
                                }
                            } else {
                                this.props.recoilStates[accessTokenState.key].setState(res.data.access_token);
                                this.props.recoilStates[phoneState.key].setState(res.data.phone);

                                this.props.tokenAction(res.data.access_token)
                                    .then(_ => { this.props.profileAction(res.data) });

                                const finalBody2 = { access_token: res.data.access_token, phone: res.data.phone };
                                fetch(`${api.extra}/api/login_otp`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                                    body: queryString.stringify(finalBody2)
                                })
                                    .then(response => {
                                        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                                        return response.json();
                                    })
                                    .then(data => {
                                        if (data.success) {
                                            this.props.history.push("/login-otp");
                                        } else {
                                            return error(t('common:error'), data.message);
                                        }
                                    });
                            }
                        }
                    });
            } else {
                error(t('common:error'), t('login:enterValidPhoneAndPassword'));
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;

        return (
            <div className="spare-dvs vh-100 align-items-start">
                <div className="w-100 float-left">

                    {/* Language switcher row (top-right). Pure UI addition. */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 12px' }}>
                        <LanguageSwitcher />
                    </div>

                    <div style={{ padding: '10px' }}>
                        <img
                            src={process.env.PUBLIC_URL + "/images/spare_logo_s.png"}
                            alt="Spare Logo"
                            className="responsive-image"
                            style={{ maxWidth: '20%' }}
                        />
                    </div>

                    <h2>{t('login:welcomeBack')}</h2>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            paddingTop: '20px'
                        }}
                    >
                        <h2>{t('login:loginTitle')}</h2>
                        <p>{t('login:enterDetails')}</p>
                        <br />
                        <div className="email-dvs">
                            <Form className="login-form" layout="vertical" onSubmit={this.handleFormSubmit}>
                                {/* Phone */}
                                <Form.Item label={t('login:phoneNumberLabel')}>
                                    {getFieldDecorator('phone', {
                                        rules: [
                                            { required: true, message: t('login:enterPhoneRequired') },
                                            {
                                                validator: (rule, value = '', callback) => {
                                                    const v = value.replace(/[- +)(]/g, '');
                                                    if (v.length < 8) callback(t('login:enterValidNumber'));
                                                    else callback();
                                                },
                                            },
                                        ],
                                    })(
                                        <PhoneInput
                                            country="us"
                                            inputProps={{ placeholder: t('login:phonePlaceholder') }}
                                            // no bottom margin here—spacing is handled by the form + CSS below
                                            inputStyle={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>

                                {/* Password */}
                                <Form.Item
                                    label={
                                        <div className="d-flex justify-content-between align-items-center" style={{ gap: '10px' }}>
                                            <span>{t('login:passwordLabel')}</span>
                                            <p
                                                className="signup-button mb-0"
                                                style={{ color: 'blue', cursor: 'pointer' }}
                                                onClick={() => this.props.history.push({ pathname: '/forgotpassword' })}
                                            >
                                                {t('login:forgotPassword')}
                                            </p>
                                        </div>
                                    }
                                >
                                    {getFieldDecorator('password', {
                                        rules: [{ required: true, message: t('login:enterPasswordRequired') }],
                                    })(
                                        <Input.Password
                                            type="password"
                                            placeholder={t('login:passwordPlaceholder')}
                                            className={this.state.pwclass}
                                        />
                                    )}
                                </Form.Item>


                                <Form.Item>
                                    {/* <input type="submit" value={t('login:loginButton')} className="w-100" /> */}
                                    {/* Or use AntD button:
                                         <Button type="primary" htmlType="submit" block>{t('login:loginButton')}</Button>
                                     */}
                                    <button
                                        className="action-button btn"
                                        type="submit"
                                    >{t('login:loginButton')}</button>
                                </Form.Item>
                            </Form>
                        </div>
                        <div>
                            <p style={{ display: 'inline' }}>{t('login:dontHaveAccount')}</p>{' '}
                            <p
                                className="signup-button"
                                style={{ color: 'blue', display: 'inline', cursor: 'pointer' }}
                                onClick={() => {
                                    this.props.history.push({ pathname: '/signup' });
                                }}
                            >
                                {t('login:signUp')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const WrappedEnterEmailForm = Form.create({ name: 'enter_otp_form' })(LoginComponent);

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            tokenAction: tokenAction,
            profileAction: profileAction
        },
        dispatch,
    );

const mapStateToProps = state => ({ token: state.token });

// NOTE: withTranslation must wrap the form component before withRouter/withRecoil/connect
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(
    withRouter(
        withRecoil(
            withTranslation(['login', 'common'])(WrappedEnterEmailForm),
            [accessTokenState, phoneState, loginOtpVerifyCount, loginOtpVerifyDate]
        )
    )
);
